import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/route-guards'
import { KuraCreateForm } from '@/components/kura-create-form'

export const Route = createFileRoute('/_authenticated/kura/create')({
  beforeLoad: requireAuth,
  component: KuraCreatePage,
})

function KuraCreatePage() {
  return (
    <div className="w-full mx-auto p-4">
      <div className="w-full mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold tracking-tight">Yeni Kura Oluştur</h1>
          <p className="text-gray-600 mt-1">Yeni bir kura oluşturmak için bilgileri doldurun</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <KuraCreateForm />
        </div>
      </div>
    </div>
  )
}